import React from "react";

import { ProductStoreCard } from "./ProductStoreCard";
import {
  ProductStoreAction,
  ProductStorePricing,
  ProductStoreSectionData,
} from "./ProductStore.types";

interface Props {
  section: ProductStoreSectionData;
  pricing: ProductStorePricing;
  openingProductType?: string;
  onAction: (action: ProductStoreAction) => void;
}

export const ProductStoreSection = ({
  section,
  pricing,
  openingProductType,
  onAction,
}: Props) => (
  <section
    className="ProductStoreSection"
    aria-labelledby={`${section.id}-title`}
  >
    <header className="ProductStoreSection__header">
      <h2 id={`${section.id}-title`}>{section.label}</h2>
      <p>{section.description}</p>
    </header>
    <div
      className={`ProductStoreSection__grid ProductStoreSection__grid--${section.id}`}
    >
      {section.products.map((product) => (
        <ProductStoreCard
          product={product}
          pricing={pricing}
          openingProductType={openingProductType}
          onAction={onAction}
          key={product.id}
        />
      ))}
    </div>
  </section>
);
